import { EigenwijsOptions } from "app/providers/DoorOptionsProvider.types";
import { useReducer } from "react";
import {
  OptionTemplate,
  SelfAssemblyMeasurements,
} from "shared/api/middleware-api-client";

type SelfAssemblyMeasurementExtended = SelfAssemblyMeasurements;

export interface SelfAssembleFields {
  label: string;
  selfAssembly: boolean;
  measurements: SelfAssemblyMeasurementExtended;
}
interface State {
  layout: OptionTemplate | null;
  eigenwijs: EigenwijsOptions | null;
  eigenwijs_layout?: string | null;
  color: OptionTemplate | null;
  glass: OptionTemplate | null;
  handle: OptionTemplate | null;
  extra: OptionTemplate[] | null;
  selectedDoor: OptionTemplate | null;

  minBeamCount: number;
  minDoorWidth: number;
  maxDoorWidth: number;
  minDoorHeight: number;
  maxDoorHeight: number;
  showBeamHeightValidationError: boolean;
  selfAssembleDoorData: SelfAssembleFields;
}

export enum DoorOptionsReducerTypes {
  UPDATE_TYPE,
  UPDATE_SELECTED_DOOR,
  UPDATE_LAYOUT,
  UPDATE_EIGENWIJS,
  UPDATE_EIGENWIJS_LAYOUT,
  UPDATE_COLOR,
  UPDATE_GLASS,
  UPDATE_HANDLE,
  UPDATE_EXTRA,
  UPDATE_MIN_DOOR_WIDTH,
  UPDATE_MAX_DOOR_WIDTH,
  UPDATE_MIN_DOOR_HEIGHT,
  UPDATE_MAX_DOOR_HEIGHT,
  UPDATE_MIN_BEAM_COUNT,
  UPDATE_SHOW_BEAM_HEIGHT_VALIDATION_ERROR,
  UPDATE_SELF_ASSEMBLE_DOOR_DATA,
}

interface Action {
  type: DoorOptionsReducerTypes;
  data: any;
}

const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case DoorOptionsReducerTypes.UPDATE_SELECTED_DOOR:
      return {
        ...state,
        selectedDoor: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_LAYOUT:
      return {
        ...state,
        layout: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_EIGENWIJS:
      return {
        ...state,
        eigenwijs: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_EIGENWIJS_LAYOUT:
      return {
        ...state,
        eigenwijs_layout: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_COLOR:
      return {
        ...state,
        color: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_GLASS:
      return {
        ...state,
        glass: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_EXTRA:
      return {
        ...state,
        extra: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_HANDLE:
      return {
        ...state,
        handle: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_MIN_DOOR_WIDTH:
      return {
        ...state,
        minDoorWidth: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_MAX_DOOR_WIDTH:
      return {
        ...state,
        maxDoorWidth: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_MIN_DOOR_HEIGHT:
      return {
        ...state,
        minDoorHeight: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_MAX_DOOR_HEIGHT:
      return {
        ...state,
        maxDoorHeight: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_MIN_BEAM_COUNT:
      return {
        ...state,
        minBeamCount: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_SHOW_BEAM_HEIGHT_VALIDATION_ERROR:
      return {
        ...state,
        showBeamHeightValidationError: action.data,
      };
    case DoorOptionsReducerTypes.UPDATE_SELF_ASSEMBLE_DOOR_DATA:
      return {
        ...state,
        selfAssembleDoorData: action.data,
      };
    default:
      return state;
  }
};

const initialState: State = {
  layout: null,
  eigenwijs: null,
  eigenwijs_layout: null,
  color: null,
  glass: null,
  handle: null,

  extra: null,
  selectedDoor: null,
  minBeamCount: 0,
  minDoorWidth: 0,
  maxDoorWidth: 0,
  minDoorHeight: 0,
  maxDoorHeight: 0,
  showBeamHeightValidationError: false,
  selfAssembleDoorData: {
    label: "",
    selfAssembly: false,
    measurements: {},
  },
};

export const useDoorOptionsReducer = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return { state, dispatch };
};
